import { t } from '@lingui/core/macro';
import { useEsigningRecipients } from 'app/domains/esigning/hooks/useEsigningRecipients';
import { useEsigningSettings } from 'app/domains/esigning/hooks/useEsigningSettings';
import { RecipientItem } from '../../../RecipientItem';
import { RecipientsAccordion } from '../../../RecipientsAccordion';
export function PendingViewerRecipients() {
    const { viewerRecipients } = useEsigningRecipients();
    const { groupMessage } = useEsigningSettings();
    if (viewerRecipients.length === 0) {
        return null;
    }
    return (<RecipientsAccordion hideTooManyItems title={t({
            message: 'Non signing parties',
            comment: 'Label for non signing parties list',
        })}>
      {viewerRecipients.map((recipient) => (<RecipientItem key={recipient.id} groupMessage={groupMessage} recipient={recipient}/>))}
    </RecipientsAccordion>);
}
